const PatAppointmentsState = {
  data: []
}

export default PatAppointmentsState
